import React from "react";

import { Orientation } from "../constants";
import { LinkOption } from "./LinkOption";
import { OrientationIcon } from "./OrientationIcon";

interface OrientationOptionProps {
  orientation: Orientation;
  isSelected: boolean;
}

export const OrientationOption: React.FC<OrientationOptionProps> = props => {
  const { isSelected, orientation } = props;
  return isSelected ? (
    <OrientationIcon {...props} />
  ) : (
    <LinkOption orientation={orientation}>
      <OrientationIcon {...props} />
    </LinkOption>
  );
};
